export const DiscountType = {
    MEMBERSHIP      : 1,
}

const discountTypeDescLangMap = {
    [DiscountType.MEMBERSHIP]    : "membership_discount",
}
export const getDiscountTypeDesc = (discountType) => {
    return lang[discountTypeDescLangMap[discountType]] || lang.discount
}